
import React from 'react';
import {
  Chart,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
import { 
  ChartContainer as ChartComponent,
  ChartTooltip,
  ChartTooltipContent
} from '../../ui/chart';

// Register chart components
Chart.register(
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    borderColor: string;
    backgroundColor: string;
    tension: number;
  }[];
}

interface AttendanceChartProps {
  chartData: ChartData;
  chartOptions: any;
  height?: string;
}

const AttendanceChart: React.FC<AttendanceChartProps> = ({
  chartData,
  chartOptions,
  height = "350px"
}) => {
  return (
    <div className={`h-[${height}] mt-4`}>
      <div className="text-center">
        <div className="flex justify-between">
          {chartData.labels.map((label, idx) => (
            <div key={idx} className="text-xs">{label}</div>
          ))}
        </div>
        <div className="h-[300px] flex items-end justify-between mb-4">
          {chartData.datasets[0].data.map((value, idx) => (
            <div 
              key={idx} 
              className="w-8 bg-green-500" 
              style={{height: `${value * 3}px`}}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AttendanceChart;
